<template>
  <div>
    <Headersys />
    <div class="content">
      <canvas class="canvas" id="qrCode" ref="qrCanvas"></canvas>
      <div>
        <!-- <div v-if="!yyzzImg"> -->
        <div v-if="print != '2'">
          <div class="title">打印营业执照</div>
          <img class="qrcoe-img" :src="codeImage" alt="" />
          <div class="tips">使用微信扫描二维码</div>
        </div>
        <div id="loadDom" v-else>
          <!-- <img class="yyzz-img" :src="yyzzImg" alt=""> -->
          <!-- <yyzzPreview :firmData="firmData" /> -->
          <img class="yyzz-img" :src="base64Data" alt="" />
        </div>
        <Back :print="print" @toPrintEve="userClice" />
      </div>
    </div>
    <div class="admin-tips">
      1.本终端暂时只支持打印2024年11月1日之后新办（换证）的营业执照
      <div>
        2.请将打印的营业执照与当前展示营业执照信息进行比对,如信息不一致,请联系技术人员
      </div>
      <div>3.技术支持电话:13176708822、17515423293</div>
    </div>
  </div>
</template>
<script>
import { Loading } from "element-ui";
import lodop from "@/assets/js/lodop";
import QRCode from "qrcode";
import yyzzPreview from "../../components/yyzzPreview.vue";
export default {
  components: { yyzzPreview },
  name: "",
  data() {
    return {
      //
      qrid: "",
      codeImage: "",
      timer: null,
      loadingInstance: null,
      waitTime: 280,
      watiTimer: null,
      yyzzImg: "",
      form: {},
      print: "1",
      firmData: {}, //展示用企业信息
      fmac: "",
      phone: "",
      name: "",
      idCard: "",
      base64Data: "",
      debounceTimer: null,
    };
  },
  created() {
    //
    // this.base64Data = "https://license.zwfwpt.cn/cc-api/profile/license/tz/596af98c-5e2d-42d2-80f6-f722885975d2.jpg"
    this.getQrCode();
    this.$fun.getMAC((mac) => {
      this.fmac = mac;
      // var userInfo = JSON.parse(localStorage.getItem('USERINFO'))
    });
    var userInfo = this.$store.state.suerInfo;
    this.name = userInfo.name;
    this.phone = userInfo.tel;
    this.idCard = userInfo.cerno;
  },
  mounted() {
    //
    this.timeDown();
  },
  destroyed() {
    // console.log('页面销毁');
    clearTimeout(this.timer);
    clearTimeout(this.watiTimer);
  },
  methods: {
    userClice() {
      this.debounce(this.checkPrint, 1000);
    },
    // 防抖函数
    debounce(fn, wait) {
      if (this.debounceTimer !== null) {
        clearTimeout(this.debounceTimer);
      }
      this.debounceTimer = setTimeout(fn, wait);
    },
    // 使用示例
    //  function handleAction() {
    //  console.log('Action performed!');
    // }

    // let debouncedAction = debounce(handleAction, 250);
    // 生成企业码
    // 生成营业执照图片
    ceratImages(data) {
      // this.$rqt.print_genYyzz(data).then(res => {
      //   this.yyzzImg = res.data.replace('http://172.16.2.9:9000', 'http://123.131.74.135:9000');
      //   this.print = '2'
      // })
      data.estdate = this.$fun.getTime(data.estdate, "年");
      data = Object.assign(data, this.$fun.disassembleTime(data.apprdate));
      if (data.regcap) {
        var regcap = data.regcap.replace(/[^0-9]/gi, "") * 10000;
        data.regcap = this.$fun.dealBigMoney(regcap);
      }
      if (data.enttype != "8") {
        var opfrom = data.opfrom;
        var opto = data.opto;
        if (opto == "99991231") {
          data.jyqx =
            opfrom.slice(0, 4) +
            " 年 " +
            opfrom.slice(4, 6) +
            " 月 " +
            opfrom.slice(6, 8) +
            " 日 至  年  月  日";
        } else {
          data.jyqx =
            opfrom.slice(0, 4) +
            " 年 " +
            opfrom.slice(4, 6) +
            " 月 " +
            opfrom.slice(6, 8) +
            " 日 至 " +
            opoptofrom.slice(0, 4) +
            " 年 " +
            opto.slice(4, 6) +
            " 月 " +
            opto.slice(6, 8) +
            " 日";
        }
      }
      this.firmData = data;
      this.print = "2";
    },
    // 倒计时
    timeDown() {
      this.watiTimer = setInterval(() => {
        if (this.waitTime > 1) {
          this.waitTime--;
        } else {
          this.waitTime = 280;
          clearInterval(this.watiTimer);
          this.$router.replace("/");
        }
      }, 1000);
    },
    // 查询是否已打印
    checkPrint() {
      var obj = this.form;
      this.creatQrCodeUrl(obj);
      return;
      // obj.apprdate 判断
      // 1722355200000
      if (obj.apprdate < 1730390400000) {
        this.$alert(
          "本终端暂时只支持打印2024年11月1日之后新办（换证）的营业执照",
          "温馨提示",
          {
            confirmButtonText: "确定",
            lockScroll: false,
          }
        );
        return;
      }
      if (obj.enttype == "1" || obj.enttype == "9" || obj.enttype == "8") {
      } else {
        this.$alert("该类型营业执照暂未开放打印,请到人工窗口办理", "温馨提示", {
          confirmButtonText: "确定",
          lockScroll: false,
        });
        return;
      }
      this.$rqt.print_getOne(obj.uniscid).then((res) => {
        // console.log('打印查询', res);
        // this.creatQrCodeUrl(obj)
        // return
        if (!res.data) {
          this.creatQrCodeUrl(obj);
        } else {
          this.$alert("营业执照已打印，请勿重复打印！", "温馨提示", {
            confirmButtonText: "确定",
            lockScroll: false,
          });
        }
      });
    },
    //获取二维码
    getQrCode() {
      this.$rqt.agent_getQrInfo().then((res) => {
        var url = res.message_content.qrimage;
        this.qrid = res.message_content.qrid;
        this.codeImage = "data:image/jpg;base64," + url;
        this.getUsrInfo();
      });
    },
    // 轮询查询用户信息
    getUsrInfo() {
      this.$rqt.agent_receiveinfo(this.qrid).then((res) => {
        if (res.data) {
          const regex = /imageurl\s*=\s*(\S+)/;
          const match = res.data.messagecontent.match(regex);
          const imageUrl = match[1].replace(new RegExp(",", "g"), "");
          this.$rqt.common_getYYZZPDF(imageUrl).then((res) => {
            this.$rqt
              .license_genPdfToJpg({
                base64: res.message_content.licencePDF,
              })
              .then((el) => {
                console.log("pdf转图片", el);
                this.base64Data = "https://license.zwfwpt.cn/cc-api/" + el.msg;
              });
            this.print = "2";
          });
          var obj = JSON.parse(res.data.baseinfo);
          // 生成营业执照预览图
          this.ceratImages(obj);
          this.form = obj;
        } else {
          this.timer = setTimeout(() => {
            this.getUsrInfo();
          }, 2000);
        }
      });
    },
    // 打印营业执照
    printZB(data, url) {
      console.log("经营范围长度", data.opscope.length);
      if (data.opscope.length > 700) {
        this.$alert(
          "您的营业执照经营范围内容过长暂不支持终端打印,请到奎文区政务服中心窗口打印",
          "提示",
          {
            confirmButtonText: "确定",
            lockScroll: false,
          }
        );
        return;
      }
      // this.savePrintRecord(data.uniscid, data.entname, data.cerno)
      // this.checkZHI()
      // this.$rqt.common_sendSms('13176708822', `${data.entname},统一社会信用代码${data.uniscid},已打印营业执照正副本,办事人:${this.name},身份证号码:${this.idCard}`)
      this.loadingInstance = Loading.service({
        fullscreen: true,
        text: "正在打印...",
        target: document.querySelector("#loadDom"),
      });
      setTimeout(() => {
        this.loadingInstance.close();
      }, 20000);
      if (data.enttype == "1") {
        // 内资公司
        lodop.YYZZZB1(data, url);
        lodop.YYZZFB1(data, url);
        return;
      }
      if (data.enttype == "3") {
        // 内资非公司企业
        lodop.YYZZZB2(data, url);
        lodop.YYZZFB2(data, url);
        return;
      }
      if (
        data.enttype == "9" ||
        data.enttype == "11" ||
        data.enttype == "12" ||
        data.enttype == "13" ||
        data.enttype == "14"
      ) {
        // 内资非公司企业
        lodop.YYZZZB3(data, url);
        lodop.YYZZFB3(data, url);
        return;
      }
      if (data.enttype == "4") {
        // 合伙企业
        lodop.YYZZZB4(data, url);
        lodop.YYZZFB4(data, url);
        return;
      }
      if (data.enttype == "6") {
        // 农民专业合作社法人
        lodop.YYZZZB6(data, url);
        lodop.YYZZFB6(data, url);
        return;
      }
      if (data.enttype == "7") {
        // 个人独资企业
        lodop.YYZZZB7(data, url);
        lodop.YYZZFB7(data, url);
        return;
      }
      if (data.enttype == "8") {
        // 个体工商户
        lodop.YYZZZB8(data, url);
        lodop.YYZZFB8(data, url);
        return;
      }
      this.$alert("外资公司请到窗口办理业务", "提示", {
        confirmButtonText: "确定",
      });
      // if (data.enttype == '15') {
      //   // 农民专业合作社分支机构
      //   lodop.YYZZZB15(data, url)
      //   lodop.YYZZFB15(data, url)
      //   return
      // }
      // lodop.YYZZZB11(data, url)
      // lodop.YYZZFB11(data, url)
    },
    savePrintRecord(uniscid, entName, printCount) {
      this.$rqt.print_save({
        uniscid,
        type: "打印营业执照",
        entName,
        fmac: this.fmac,
        name: this.name,
        phone: this.phone,
        idCard: this.idCard,
        printCount,
      });
    },
    // 生成二维码路径
    creatQrCodeUrl(data) {
      this.printZB(this.firmData, "");
      return;
      this.$rqt.print_getEntCode(data.uniscid, data.entname).then((res) => {
        console.log(res);
        var data = JSON.parse(res.msg);
        if (data.message_content.qrimage) {
          var codeUrl = "data:image/jpg;base64," + data.message_content.qrimage;
          this.printZB(this.firmData, codeUrl);
        } else {
          this.$alert(data.message_header.errorInfo, "提示", {
            confirmButtonText: "确定",
            lockScroll: false,
          });
        }
      });
      // this.$rqt.print_getEntCode().then(res => {
      //   var data = JSON.parse(res.data)
      //   var codeUrl = "data:image/jpg;base64," + data.message_content.qrimage
      //   this.printZB(this.firmData, codeUrl);

      // })
      // data.estdate = this.$fun.getTime(data.estdate, '年')
      // data = Object.assign(data, this.$fun.disassembleTime(data.apprdate))
      // if (data.regcap) {
      //   var regcap = data.regcap.replace(/[^0-9]/ig, "") * 10000
      //   data.regcap = this.$fun.dealBigMoney(regcap)
      // }
      // if (data.enttype != '8') {
      //   var opfrom = data.opfrom
      //   var opto = data.opto
      //   if (opto == '99991231') {
      //     data.jyqx = opfrom.slice(0, 4) + " 年 " + opfrom.slice(4, 6) + " 月 " + opfrom.slice(6, 8) + " 日 至  年  月  日"
      //   } else {
      //     data.jyqx = opfrom.slice(0, 4) + " 年 " + opfrom.slice(4, 6) + " 月 " + opfrom.slice(6, 8) + " 日 至 " + opoptofrom.slice(0, 4) + " 年 " + opto.slice(4, 6) + " 月 " + opto.slice(6, 8) + " 日"
      //   }
      // }
      // this.createQRWithImage(this.firmData)
      // var _this = this
      // 创建一个二维码
      // QRCode.toDataURL(`https://www.gsxt.gov.cn/index.html?uniscid=${data.uniscid}`, function (err, url) {
      //   if (err) console.error(err);
      //   // 此时的url就是二维码图片的base64编码的DataURL
      //   _this.printZB(data, url);
      // });
    },
    // 营业执照打印记录
    checkZHI() {
      this.$rqt.Selfservice_count(this.fmac);
      this.$rqt.Selfservice_getByMac({ fmac: this.fmac }).then((res) => {
        var list = res.data;
        list.forEach((el) => {
          if (el.fcredentialsid == "yyzzzb") {
            if (el.fpaperqty < 6) {
              this.$rqt.common_sendSms(
                el.fphone,
                `${el.fname}设备。打印纸张还剩${el.fpaperqty}张，请及时添加。`
              );
            }
          }
        });
      });
      // this.$rqt.license_savePrintRecord({
      //   "printMachineMac": this.fmac,
      //   "trayid": "yyzzzb",
      //   flag: 5,
      // }).then(res => {
      //   if (res.code == 500) {
      //     this.$rqt.common_sendSms(res.data.fphone, res.msg);
      //   }
      // })
    },
    goBack() {
      this.$router.back();
    },
    // createQRWithImage(data) {
    //   var _this = this
    //   var imagePath = require('@/assets/images/code-img.png')
    //   var canvas = document.getElementById("qrCode");
    //   QRCode.toCanvas(
    //     canvas,
    //     `https://www.gsxt.gov.cn/index.html?uniscid=${data.uniscid}`,
    //     { errorCorrectionLevel: 'H', version: 15 },
    //     function (error) {
    //       if (error) {
    //         console.error(error);
    //       } else {
    //         const canvas = _this.$refs.qrCanvas
    //         const ctx = canvas.getContext('2d')
    //         const img = new Image()
    //         img.src = imagePath
    //         img.onload = () => {
    //           // 计算图片的位置，使其位于二维码的中心
    //           const imageWidth = canvas.width * 0.2
    //           const x = (canvas.width - imageWidth) / 2
    //           const y = (canvas.height - imageWidth) / 2
    //           // 绘制图片
    //           ctx.drawImage(img, x, y, imageWidth, imageWidth)
    //           var urls = canvas.toDataURL()
    //           // console.log(urls);
    //           _this.printZB(data, urls);
    //         }
    //       }
    //     }
    //   );
    // },
  },
};
</script>
<style scoped lang="scss">
.content {
  height: calc(100vh - 42rem);
  background-color: #fff;
  padding: 0 5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.content::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

.title {
  font-size: 10rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 3rem;
}

.qrcoe-img {
  display: block;
  width: 70rem;
  height: 70rem;
  margin-bottom: 4rem;
}

.tips {
  font-size: 6rem;
  font-weight: bold;
  text-align: center;
}

.goback-btn {
  width: fit-content;
  font-size: 8rem;
  background-color: #0099ff;
  border-radius: 2rem;
  margin: 10rem auto 0;
  font-weight: bold;
  color: #ffffff;
  padding: 3rem 5rem;
}

.yyzz-img {
  display: block;
  margin: auto;
  width: 58%;
  transform: translateY(-10rem);
}

.canvas {
  width: 200px !important;
  height: 200px !important;
  position: fixed;
  top: -999rem;
  left: -999rem;
}

.admin-tips {
  position: fixed;
  bottom: 30rem;
  right: 10rem;
  color: red;
  font-size: 6rem;
  font-weight: bold;
  width: 120rem;
}
</style>
